module.exports = __webpack_public_path__ + "img/facebook.5144cf96.svg";